"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _defaultTo = _interopRequireDefault(require("lodash/fp/defaultTo"));
var _curryRight = _interopRequireDefault(require("lodash/fp/curryRight"));
var _eventHandler = require("@active/react-utils/eventHandler");
var _i18n = require("@active/react-utils/i18n");
var _hoc = require("@active/react-utils/hoc");
var _MenuContext = require("../Menu/MenuContext");
var _excluded = ["children", "className", "disabled", "img", "isActive", "isSelected", "onClick", "onItemClick", "onItemConfirmKeyDown", "selected", "type", "value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var RegularMenuItem = function RegularMenuItem(_ref) {
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    img = _ref.img,
    isActive = _ref.isActive,
    isSelected = _ref.isSelected,
    onClick = _ref.onClick,
    onItemClick = _ref.onItemClick,
    onItemConfirmKeyDown = _ref.onItemConfirmKeyDown,
    selected = _ref.selected,
    type = _ref.type,
    value = _ref.value,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var itemRef = (0, _react.useRef)(null);
  var tabIndex = isActive ? 0 : -1;
  var _useLocale = (0, _i18n.useLocale)(),
    i18n = _useLocale.i18n;
  var handleClick = (0, _react.useCallback)(function (e) {
    onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(value);
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  }, [value, onItemClick, onClick]);
  var handleKeyDown = (0, _eventHandler.useOnKeyboardConfirm)(function (e) {
    onItemConfirmKeyDown === null || onItemConfirmKeyDown === void 0 ? void 0 : onItemConfirmKeyDown(value);
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  }, [value, onItemConfirmKeyDown, onClick]);
  var baseProps = {
    tabIndex: disabled ? undefined : tabIndex,
    onClick: disabled ? undefined : handleClick,
    onKeyDown: disabled ? undefined : handleKeyDown
  };
  var getSelected = function getSelected() {
    return (0, _defaultTo["default"])(isSelected === null || isSelected === void 0 ? void 0 : isSelected(value))(selected);
  };
  var ariaProps = type === 'listbox' ? {
    role: 'option',
    'aria-selected': getSelected()
  } : {
    role: 'menuitem'
  };
  var getAriaLabel = function getAriaLabel() {
    return getSelected() && typeof children === 'string' ? "".concat(children, ", ").concat(i18n('react-ui.menu.item.ariaLabel.selected')) : undefined;
  };
  return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({
    ref: itemRef,
    className: (0, _classnames["default"])('menu-item', {
      selected: getSelected(),
      disabled: disabled
    }, className),
    "aria-label": getAriaLabel()
  }, baseProps, ariaProps, rest, {
    "data-value": value
  }), getSelected() && /*#__PURE__*/_react["default"].createElement("span", {
    className: "menu-item-selected-icon",
    "aria-hidden": "true"
  }), img ? /*#__PURE__*/_react["default"].createElement("img", {
    className: "menu-item-img",
    src: img,
    alt: ""
  }) : null, children);
};
var Composed = (0, _compose["default"])((0, _curryRight["default"])((0, _hoc.connect)(_MenuContext.MenuConsumer))(function (_ref2, _ref3) {
  var activeItem = _ref2.activeItem,
    type = _ref2.type,
    isSelected = _ref2.isSelected,
    onItemClick = _ref2.onItemClick,
    onItemConfirmKeyDown = _ref2.onItemConfirmKeyDown;
  var value = _ref3.value;
  return {
    isActive: value === activeItem,
    isSelected: isSelected,
    type: type,
    onItemClick: onItemClick,
    onItemConfirmKeyDown: onItemConfirmKeyDown
  };
}), _react.memo)(RegularMenuItem);
Composed.displayName = 'RegularMenuItem';
var _default = exports["default"] = Composed;